const AMBER = new Set([
  "open", "not confirmed", "not verified", "restricted", "pending", "draft", "in closeout", "unknown",
]);
const POSITIVE = new Set(["confirmed", "complete", "completed", "approved", "verified", "closed", "resolved", "active"]);

export function StatusBadge({ status, className = "", "data-testid": testId }) {
  const key = (status || "").toString().toLowerCase();
  let style = "text-[#A1A19D] bg-[#1F1F1D] border-[#2C2C2A]"; // neutral
  if (AMBER.has(key)) style = "text-[#F59E0B] bg-[rgba(245,158,11,0.12)] border-[rgba(245,158,11,0.3)]";
  else if (POSITIVE.has(key)) style = "text-[#8FB97A] bg-[rgba(143,185,122,0.12)] border-[rgba(143,185,122,0.3)]";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${style} ${className}`}
    >
      {status}
    </span>
  );
}
